import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Button} from "./Button";
import Modal from "./Modal";
import {bindActionCreators} from "redux";
// import ModalSubscription from "./ModalSubscription";
import history from "../../libs/history";
import EmailValidation from "./SignUpInformation/components/EmailValidation";
//import Signin from "../pages/Signin";
import ModalEncourageSignup from "../components2/encourageSignup/EncourageSignup";


class CtaCannot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            togglePopup: false,
        };
        this.propBtn = {
            className : "add-user mr-16",
            btnStyle : "primary",
            size : "small",
            content : "",
            ...this.props.button
        };
        this.openModal = this.openModal.bind(this);
    }

    openModal(){
        !this.state.togglePopup && this.setState({togglePopup: true});
        if(this.props.openModal){
            this.props.openModal();
        }
    }


    render() {
        this.modal = this.props.clickCta[this.props.action];
        return (
            this.props.clickCta && this.modal && this.props.currentUserInitialized ? (
                <Fragment>
                    {this.props.isModal && this.modal &&  this.modal.modal ? (
                        <Fragment>
                            {this.props.children ? (
                                <div onClick={() => this.openModal()}>
                                    {this.props.children}
                                </div>
                            ) : (
                                <Button {...this.propBtn}
                                        active={this.state.togglePopup}
                                        onClick={() => this.openModal()}
                                />
                            )}
                            {this.modal.modal === EmailValidation ? <EmailValidation toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})} /> : (
                                <Modal toggle={this.state.togglePopup} handleClose={() => this.setState({togglePopup: false})}>
                                    <this.modal.modal username={this.props.currentUser.username} userId={this.props.currentUser._id} handleClose={() => this.setState({togglePopup: false})} />
                                </Modal>
                            )}

                        </Fragment>
                    ) : (
                        this.props.children ? (
                            <div  onClick={() => this.modal.to ? history.push(this.modal.to) : null}>
                                {this.props.children}
                            </div>
                        ) : (
                                <Button {...this.propBtn}
                                        onClick={() => this.modal.to ? history.push(this.modal.to) : null}
                                />
                            )
                    )}
                </Fragment>
            ) : (
                <Fragment>
                    {this.props.children ? (
                        <div onClick={() => this.openModal()}>
                            {this.props.children}
                        </div>
                    ) : (
                        <Button {...this.propBtn}
                                active={this.state.togglePopup}
                                onClick={() => this.openModal()}
                        />
                    )}

                        <ModalEncourageSignup
                            toggle={this.state.togglePopup}
                            handleClose={() => this.setState({togglePopup: false}) }
                        />
                </Fragment>
                // <Button {...this.propBtn}
                //         onClick={() => history.push(createLink("signup"))}
                // />
            )
        )
    }
}

const mapStateToProps = (state) => {
    return {
        clickCta : state.clickCta.data,
        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(CtaCannot);

